export enum EPermission {
  Allow = 'allow',
  PermissionSetting = 'permission.setting',
  Dashboard = 'dashboard.view',
  Genearal = 'general',
  Report = 'report',

  ProductView = 'product.view',
  ProductEdit = 'product.edit',
  ProductDelete = 'product.delete',
  ProductAdd = 'product.add',

  StockView = 'stock.view',
  StockEdit = 'stock.edit',
  StockDelete = 'stock.delete',
  StockAdd = 'stock.add',

  CustomerView = 'customer.view',
  CustomerEdit = 'customer.edit',
  CustomerDelete = 'customer.delete',
  CustomerAdd = 'customer.add',

  DriverView = 'driver.view',
  DriverEdit = 'driver.edit',
  DriverDelete = 'driver.delete',
  DriverAdd = 'driver.add',

  TransportView = 'transport.view',
  TransportEdit = 'transport.edit',
  TransportDelete = 'transport.delete',
  TransportAdd = 'transport.add',
  TransportPrice = 'transport.price',

  VehicleView = 'vehicle.view',
  VehicleEdit = 'vehicle.edit',
  VehicleDelete = 'vehicle.delete',
  VehicleAdd = 'vehicle.add',
  VehiclePrice = 'vehicle.price',

  SettingView = 'setting.view',
  SettingEdit = 'setting.edit',
  SettingDelete = 'setting.delete',
  SettingAdd = 'setting.add',
  SettingPrice = 'setting.price',

  LocationView = 'location.view',
  LocationEdit = 'location.edit',
  LocationDelete = 'location.delete',
  LocationAdd = 'location.add',
  LocationPrice = 'location.price',

  RouteView = 'route.view',
  RouteEdit = 'route.edit',
  RouteDelete = 'route.delete',
  RouteAdd = 'route.add',
  RoutePrice = 'route.price',

  WorklogView = 'worklog.view',
  WorklogEdit = 'worklog.edit',
  WorklogDelete = 'worklog.delete',
  WorklogAdd = 'worklog.add',
  WorklogPrice = 'worklog.price',
  WorklogReport = 'worklog.report',
  WorklogManage = 'worklog.manage',
}

export enum EPermissionGroup {
  Dashboard = 'dashboard',
  Product = 'product',
  Stock = 'stock',
  Customer = 'customer',
  Setting = 'setting',
  Route = 'route',
  Location = 'location',
  Driver = 'driver',
  Transport = 'transport',
  Vehicle = 'vehicle',
  Worklog = 'worklog',
}
